import classnames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseErrorView } from '../base-error-view/BaseErrorView';
import styles from './ErrorMessageWrapper.module.scss';

type Variant = 'error' | 'empty';

export interface ErrorMessageWrapperProps {
  variant?: Variant;
  displayIcon?: boolean;
  title?: string;
  subTitle?: string;
  showBorder?: boolean;
}

export const ErrorMessageWrapper = ({
  displayIcon,
  variant = 'error',
  title,
  subTitle,
  showBorder = true,
  ...rest
}: ErrorMessageWrapperProps) => {
  const { t } = useTranslation(['widget', 'common']);

  const messageComponent = {
    error: (
      <BaseErrorView
        title={title}
        subtitle={subTitle}
        displayIcon={displayIcon ? 'error' : undefined}
      />
    ),
    empty: (
      <BaseErrorView
        displayIcon={displayIcon ? 'empty' : undefined}
        title={title ?? t('widget:empty.titleEmpty')}
        subtitle={subTitle ?? t('widget:empty.subtitleEmpty')}
      />
    ),
  };

  return (
    <div
      {...rest}
      className={classnames(styles.styledErrorMessageRoot, {
        [styles.showBorder]: showBorder,
      })}
    >
      {messageComponent[variant]}
    </div>
  );
};
